import { render, staticRenderFns } from "./AdminCategories.vue?vue&type=template&id=3d29ebd9&scoped=true"
import script from "./AdminCategories.vue?vue&type=script&lang=js"
export * from "./AdminCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d29ebd9",
  null
  
)

export default component.exports